import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import FormField from '../../../components/FormField';
import { phoneFormatter } from '../../../helpers/helpers';
import normalizer from '../../../helpers/inputNormalizer';
import messages from '../PersonalInformation.messages';
import { FieldWrapper } from '../types/PersonalInformation.types';

export const renderPhones = (
    phone: FieldWrapper<{ number: string; type: string; uid: string }[]>
) => {
    const main = _.find(phone, { type: { value: 'main' } });
    const secondary = _.find(phone, { type: { value: 'secondary' } });

    if (!main || !secondary) {
        return null;
    }

    const maskedFieldMain = normalizer(main.number, phoneFormatter, null);

    return (
        <FormField
            wrapperClassName="fs-exclude"
            label={<FormattedMessage {...messages.mainPhoneNumber} />}
            field={maskedFieldMain}
            tooltip={<FormattedMessage {...messages.mainPhoneNumberTooltip} />}>
            <FormField.Input
                whenBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                    if (event?.target?.value?.length > 0) {
                        tracking.ampli.formFieldCompleted({
                            form_field: 'phone_number'
                        });
                    }
                }}
                className="xs-push"
            />
        </FormField>
    );
};
